import {Occurrence} from '../office/types';

export interface DailyCareLogContextState {
  navigationHeader: {
    active: boolean;
    text: string;
  };
  bottomNavigation: {
    visible: boolean;
    active: boolean;
  };
  occurrence?: Occurrence;
}

export enum DailyCareLogContextActionType {
  UPDATE_VIEW_MODE = 'UPDATE_VIEW_MODE',
  SET_NAVIGATION_HEADER = 'SET_NAVIGATION_HEADER',
  TOGGLE_BOTTOM_NAVIGATION = 'TOGGLE_BOTTOM_NAVIGATION',
}

export type DailyCareLogContextAction =
  | {
      type: DailyCareLogContextActionType.SET_NAVIGATION_HEADER;
      active: boolean;
      text: string;
    }
  | {
      type: DailyCareLogContextActionType.TOGGLE_BOTTOM_NAVIGATION;
      visible: boolean;
      active: boolean;
    };

export interface DailyCareLogContextType {
  state: DailyCareLogContextState;

  // Methods
  setNavigationHeader: ((reason?: string) => void) | undefined | any;
  toggleBottomNavigation: (() => void) | undefined | any;
}
